import React from 'react'

//* Translations
import strings from 'translations/strings.json'

//* Styles
import styles from './CartHeaders.module.scss';

const CartHeaders = () => {
    
    const LANG = document.documentElement.lang.substring(0, 2).toLowerCase()
    const STRINGS_LANG = strings.hasOwnProperty(LANG) ? strings[LANG] : strings["en"]

  return (
    <div className={styles["cart-headers"]}>
        <div className={`${styles["cart-header"]} ${styles["product"]}`}>
            <p className={styles["label"]}>{STRINGS_LANG.product}</p>
        </div>
        <div className={`${styles["cart-header"]} ${styles["price"]}`}>
            <p className={styles["label"]}>{STRINGS_LANG.price}</p>
        </div>
        <div className={`${styles["cart-header"]} ${styles["quantity"]}`}>
            <p className={styles["label"]}>{STRINGS_LANG.quantity}</p>
        </div>
        <div className={`${styles["cart-header"]} ${styles["subtotal"]}`}>
            <p className={styles["label"]}>{STRINGS_LANG.subtotal}</p>
        </div>
        <div className={`${styles["cart-header"]} ${styles["remove"]}`}>
        </div>
    </div>
  )
}

export default CartHeaders